import { Box, Typography } from "@mui/material";
import { Dispatch, memo, SetStateAction } from "react";
import { ApprovedIcon, CancelIcon } from "../../../../components/MuiIcons";
import { fromBase64 } from "../../../../utils/base64";
import { TDocumentData, TDocumentDataScreeningReportData } from "../../models";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

export type ScreeningReportContentProps = {
  data: TDocumentData;
  setDataFields: Dispatch<SetStateAction<{}>>;
  dataFields: object;
  allDisabled?: boolean;
};

export const ScreeningReportContent = memo(
  (props: ScreeningReportContentProps) => {
    const { data } = props;

    let parsedData: TDocumentDataScreeningReportData | null = null;
    try {
      parsedData = JSON.parse(fromBase64(data.dataBase64));
    } catch (e) {
      console.error("Failed to parse base64 data:", e);
    }

    if (!parsedData) {
      return null;
    }

    return (
      <div>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {parsedData.title || "Screening Report"}
        </Typography>
        {parsedData.checks?.map((check, index) => (
          <>
            <Box>
              <strong>{check.name}</strong>
              {check.failed ? (
                <span style={{ color: "red" }}>
                  {" "}
                  <CancelIcon sx={{ verticalAlign: "middle" }} />
                  Failed
                </span>
              ): check.review_needed ? (
                <span style={{ color: "orange" }}>
                  {" "}
                  <WarningRoundedIcon sx={{ verticalAlign: "middle" }} />
                  Review needed
                </span>
              ) : (
                <span style={{ color: "green" }}>
                  {" "}
                  <ApprovedIcon sx={{ verticalAlign: "middle" }} />
                  Passed
                </span>
              )}
            </Box>
            <Box sx={{ mb: 1 }}>
              <Typography variant="body2">{check.description}</Typography>
            </Box>
          </>
        ))}
      </div>
    );
  }
);
